import { PagedListResponse, SuccessResponse, User, X5LessonSnapshot } from 'domain/index';
import { HttpPromiseState } from 'lib/helpers';
import { environment } from 'lib/environment';
import { httpClient } from 'domain/utils/httpClient';
import {
    EssayViewModel,
    EssayStudentSubmitViewModel,
    EssayTeacherSubmitViewModel,
    EssayTeacherListResponse,
    EssayStudentSaveViewModel,
    ExamStudentListResponse,
    EssayListDto,
    FinishExamRequest,
    FinishExamResponse,
    TeacherExamResultResponse
} from './ExamModels';
import { AxiosRequestConfig } from 'axios';

class ExamLoadersClass {
    getEssay(essayId: number): HttpPromiseState<EssayViewModel> {
        let url = `${environment.apiServer}/essay/open`;
        const cfg: AxiosRequestConfig = {
            params: { essayId }
        };
        return httpClient.state.get<EssayViewModel>(url, cfg);
    }

    studentSubmit(essayId: number, text: string) {
        const url = `${environment.apiServer}/essay/student/submit`;
        const data = new EssayStudentSubmitViewModel(essayId, text);
        return httpClient.axios.postWithSweetAlert(url, data);
    }

    studentSave(essayId: number, text: string) {
        const url = `${environment.apiServer}/essay/student/save`;
        const data = new EssayStudentSaveViewModel(essayId, text);
        return httpClient.axios.postWithSweetAlert(url, data);
    }

    teacherSubmit(essayId: number, text: string, accept: boolean, rating: number | null, comment: string | null) {
        const url = `${environment.apiServer}/essay/teacher/submit`;
        const data = new EssayTeacherSubmitViewModel(essayId, text, accept, rating, comment);
        return httpClient.axios.postWithSweetAlert(url, data);
    }

    teacherGetList(request: EssayListDto) {
        const url = `${environment.apiServer}/exam/teacher/list`;
        return httpClient.state.post<ExamStudentListResponse>(url, request);
    }

    studentGetList(request: EssayListDto) {
        const url = `${environment.apiServer}/exam/student/list`;
        return httpClient.state.post<ExamStudentListResponse>(url, request);
    }

    async finishExam(request: FinishExamRequest): Promise<FinishExamResponse> {
        const url = `${environment.apiServer}/exam/finish`;
        const response = await httpClient.axios.post<FinishExamResponse>(url, request);
        return response.data;
    }

    async getExamResult(examId: number): Promise<FinishExamResponse> {
        const url = `${environment.apiServer}/exam/${examId}/result`;
        const response = await httpClient.axios.get<FinishExamResponse>(url);
        return response.data;
    }

    async teacherGetExamResult(examId: number): Promise<TeacherExamResultResponse> {
        const url = `${environment.apiServer}/teacher/exam/${examId}/result`;
        const response = await httpClient.axios.get<TeacherExamResultResponse>(url);
        return response.data;
    }

    async teacherGetExamLessonSnapshot(examId: number): Promise<X5LessonSnapshot> {
        const url = `${environment.apiServer}/teacher/exam/${examId}/lesson-snapshot`;
        const response = await httpClient.axios.get<X5LessonSnapshot>(url);
        return response.data;
    }
}

export const ExamLoaders = new ExamLoadersClass();
